import { useLang } from '../i18n/LangContext';

export const Marquee = () => {
  const { t } = useLang();
  return (
  <div data-testid="editorial-marquee" aria-hidden="true" className="relative overflow-hidden border-y border-white/10 bg-krug-deep py-5">
    <div className="marquee-track items-center gap-10">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center gap-10 pr-10">
          {t.marquee.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center gap-10 whitespace-nowrap">
              <span className="font-heading text-sm md:text-base font-bold tracking-[0.3em] uppercase text-slate-500">
                {item}
              </span>
              <span className="w-2 h-2 rounded-full bg-krug-gold/70" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
  );
};
